class ThumbnailService {
    getAround(files, index, count = 5) {
        if (!files || files.length === 0) {
            return [];
        }

        let start = index - Math.floor(count / 2);

        if (start < 0) {
            start = 0;
        }

        if (start + count > files.length) {
            start = Math.max(files.length - count, 0);
        }

        return files.slice(start, start + count)
            .map((item, i) => ({
                ...item,
                index: start + i
            }));
    }
}
export default new ThumbnailService();